import { createContext } from 'react';

export const ChangePINContext = createContext({
});

export const ChangePINProvider = ChangePINContext.Provider;
